<template>
  <div>
    <v-btn color="black" dark @click="add_new_dialog=true" small round >+</v-btn>
      <v-dialog v-model="add_new_dialog" max-width="900px">
        <v-card class="elevation-0 xs12 pa-4" >
          <v-card-title class="headline" >Add New Tag</v-card-title>
          <v-card-title v-if="c_user.edit"
            :class="{
              'my-0': true,
              black: save_tag_form_display || save_tag_category_form_display
            }"
          >
            <v-btn-toggle mandatory  v-model="category">
              <v-btn flat value="concept">
                <span>Conceptual</span>
              </v-btn>
              <v-btn flat value="cataloguing">
                <span>Cataloguing</span>
              </v-btn>
              <v-btn flat value="private">
                <span>Private</span>
              </v-btn>

            </v-btn-toggle>
            <!-- <v-btn
              v-if="
                !save_tag_category_form_display ||
                  (save_tag_category_form_display && save_tag_form_display)
              "
              @click="show_save_tag_form"
              class="elevation-0"
              >+ Add New Tag</v-btn
            > -->
          </v-card-title>

          <!-- // Add Tag Category Form -->
          <v-card-title xs12>
            <!-- <transition name="fade" mode="out-in"> -->
            <!-- <v-list-tile>
              <v-layout mx-0 xs12> -->
                <v-flex xs6 mx-2>
                  <v-combobox
                  v-model="subcategory"
                  :items="all_categories"
                  label="Tag Category"
                  ></v-combobox>
                  <!-- item-text="subcategory"
                  item-value="subcategory" -->
                </v-flex>
                <v-flex xs12 mx-2>
                  <v-text-field
                    v-model="tag_title"
                    label="Tag Title"
                    flat
                    value=""
                    class="input-group mt-4 py-0"
                    :dark="save_tag_form_display"
                  ></v-text-field>
                </v-flex>
              <!-- </v-layout> -->
              <v-spacer></v-spacer>
              <v-btn outline color="black" @click="add_new_dialog=false" >Cancel</v-btn >
              <v-btn
                outline
                color="green"
                v-if="this.tag_title.length > 0"
                @click="create_tag"
                >Save</v-btn
              >
            <!-- </v-list-tile> -->
            <!-- </transition>
            <transition name="fade" mode="out-in"> -->
            <v-list-tile v-if="save_tag_category_form_display">
              <v-layout row my-0 py-0 mx-0>
                <v-flex xs12 my-0 py-0>
                  <!-- label="Tag Category Title" -->
                  <v-text-field
                    solo
                    v-model="tag_category_name"
                    value=""
                    color="white"
                    class="input-group dark mt-4 py-0 mr-3"
                    :dark="save_tag_category_form_display"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-spacer></v-spacer>
              <v-btn
                outline
                color="black"
                @click="add_new_dialog = false"
                >Cancel</v-btn
              >
              <v-btn
                outline
                color="green"
                v-if="this.tag_category_name.length > 0"
                @click="create_tag_category"
                >Save</v-btn
              >
            </v-list-tile>
            <!-- </transition> -->
          </v-card-title>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import axios from 'axios'
export default {
    name: 'AddNew',
    data: () => ({
        save_tag_form_display: false,
        save_tag_category_form_display: false,
        add_new_dialog: false,
        tag_title: '',
        tag_category_id: '',
        tag_category_name: '',
        // all_categories: [],
        category: "concept",
        subcategory: "",
    }),
    methods: {
        show_save_tag_form() {
            this.save_tag_form_display = !this.save_tag_form_display;
        },
        show_save_tag_category_form() {
            this.save_tag_category_form_display = !this.save_tag_category_form_display;
        },
        create_tag() {
          let url = `${this.$globals.apiserver}/tags.json`
          axios
            .post(url, {
              tag: {
                name: this.tag_title,
                category: this.category,
                section: this.category,
                subcategory: this.subcategory,
                tag_category_id: "",
                created_by: this.$store.state.user_id
              }
            })
            .then(response => {
              this.$store.dispatch('loadTags')
              this.save_tag_form_display = false
              this.tag_title = ''
            })
            .catch(error => {
              console.log(error)
            })
        },

        // create_tag() {
        //     this.$store.dispatch('createTag', {
        //         title: this.tag_title,
        //         category_id: this.tag_category_id
        //     });
        //     this.tag_title = '';
        //     this.tag_category_id = '';
        //     this.save_tag_form_display = false;
        // },
        // create_tag_category() {
        //     this.$store.dispatch('createTagCategory', {
        //         name: this.tag_category_name
        //     });
        //     this.tag_category_name = '';
        //     this.save_tag_category_form_display = false;
        // }
    },
    computed: {
      all_categories() {
        if (this.category === "concept") {
          // return this.categories.filter(category => category.type === "concept");
          return this.$store.getters.conceptual_tag_categories.map(t => t.subcategory)
        } else if (this.category === "cataloguing") {
          return this.$store.getters.cataloguing_tag_subcategories.map(a => a.subcategory).sort();
          // return this.categories.filter(category => category.type === "cataloguing");
        } else if (this.category === "private") {
          return ["private"];
          // return this.categories.filter(category => category.type === "private");
        }
      },
      categories() {
        return this.$store.state.conceptual_tag_categories
      },
      subcategories() {
        return this.$store.state.tag_subcategories
      },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/tags/AddNew.vue